// extracted by mini-css-extract-plugin
export default {"productGallery":"lN-z","inQuickShop":"mN-z"};